import { setGetListEventsAction } from '../action';
import { getListEvents } from '../api/getListEvents';

const setGetListEvents = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListEvents(params);

            if (data.status === 'success') {
                dispatch(setGetListEventsAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListEvents
}